
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"54","viewBox":"0 0 34 54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0.420455 54V49.3977L17.7045 30.4773C19.733 28.2614 21.4034 26.3352 22.7159 24.6989C24.0284 23.0455 25 21.4943 25.6307 20.0455C26.2784 18.5795 26.6023 17.0455 26.6023 15.4432C26.6023 13.6023 26.1591 12.0085 25.2727 10.6619C24.4034 9.31534 23.2102 8.27557 21.6932 7.54261C20.1761 6.80966 18.4716 6.44318 16.5795 6.44318C14.5682 6.44318 12.8125 6.86079 11.3125 7.69602C9.82955 8.5142 8.67898 9.66477 7.8608 11.1477C7.05966 12.6307 6.65909 14.3693 6.65909 16.3636H0.625C0.625 13.2955 1.33239 10.6023 2.74716 8.28409C4.16193 5.96591 6.08807 4.15909 8.52557 2.86363C10.9801 1.56818 13.733 0.920453 16.7841 0.920453C19.8523 0.920453 22.571 1.56818 24.9403 2.86363C27.3097 4.15909 29.1676 5.90625 30.5142 8.10511C31.8608 10.304 32.5341 12.75 32.5341 15.4432C32.5341 17.3693 32.1847 19.2528 31.4858 21.0938C30.804 22.9176 29.6108 24.9545 27.9062 27.2045C26.2188 29.4375 23.875 32.1648 20.875 35.3864L9.11364 47.9659V48.375H33.4545V54H0.420455Z","fill":"#00A669"}})])
          )
        }
      }
    